export const board = [
  {
    name: "Inês Miranda",
    role: "Presidente",
    img: "img/team/Direcao_Ines.JPG",
    ig: "_ines_mirandaa_",
    fb: null,
    ld: null
  },
  {
    name: "Mariana Mendes",
    role: "Vice-Presidente (RE)",
    img: "img/team/Direcao_Mariana.JPG",
    ig: "mmarianam3",
    fb: null,
    ld: "mariana-mendes-685578255"
  },
  {
    name: "João Sá",
    role: "Vice-Presidente (RH)",
    img: "img/team/Direcao_Sa.JPG",
    ig: "joao_sa_50",
    fb: "joao.sa.03",
    ld: "joão-sá-92a7842b9"
  },
  {
    name: "Maria Muguerza",
    role: "Secretária-Geral",
    img: "img/team/Direcao_Maria.JPG",
    ig: "_.maria.oliveiraa_",
    fb: null,
    ld: "maria-muguerza-150690361"
  },
  {
    name: "Maria João",
    role: "Tesoureira",
    img: "img/team/Direcao_MJ.JPG",
    ig: "mariaajoao05",
    fb: null,
    ld: "mariajotabranco2005"
  },
]

export const mag = [
  {
    name: "Beatriz Mota",
    role: "Presidente",
    img: "img/team/MAG_BeatrizMota.JPG",
    ig: "biacmota22",
    fb: null,
    ld: "beatriz-mota-3874a9338"
  },
  {
    name: "Beatriz Oliveira",
    role: "Vice-Presidente",
    img: "img/team/MAG_BeatrizO.JPG",
    ig: "beatriz__21_",
    fb: null,
    ld: null
  },
  {
    name: "Victória Meireles",
    role: "Secretária",
    img: "img/team/MAG_Victoria.JPG",
    ig: "victoriaameireles.01",
    fb: null,
    ld: null
  },
]

export const fiscal_council = [
  {
    name: "Matilde Dias",
    role: "Presidente",
    img: "img/team/CF_Matilde.JPG",
    ig: "matildelldias",
    fb: null,
    ld: null
  },
  {
    name: "Joana Santos",
    role: "Vice-Presidente",
    img: "img/team/CF_Joana.JPG",
    ig: "_joana.santos._",
    fb: null,
    ld: null
  },
  {
    name: "Beatriz Correia",
    role: "Secretária",
    img: "img/team/CF_Beatriz.JPG",
    ig: "beatriz_correia22_",
    fb: null,
    ld: null
  },
]

// Recreativo
export const rec_department = [
  {
    name: "Margarida Figueira",
    role: "Recreativo",
    img: "img/team/Rec_Margarida.JPG",
    ig: "margarida_gf66",
    fb: null,
    ld: null
  },
  {
    name: "João Rocha",
    role: "Recreativo",
    img: "img/team/Rec_Joao.JPG",
    ig: "joaorocha1110",
    fb: null,
    ld: "joão-rocha-5ba527269"
  },
  {
    name: "Inês Laranjeira",
    role: "Recreativo",
    img: "img/team/Rec_Ines.JPG",
    ig: "iness_almeiida",
    fb: null,
    ld: null
  },
]

// Marketing
export const marketing_department = [
  {
    name: "Simão Andrade",
    role: "Marketing",
    img: "img/team/MKT_Simao.jpeg",
    ig: "simao_andrade06",
    fb: null,
    ld: "simão-andrade-456098413"
  },
  {
    name: "Lara Pereira",
    role: "Marketing",
    img: "img/team/MKT_Lara.jpeg",
    ig: "lara_pereira05",
    fb: null,
    ld: "lara-pereira-2b7b81361"
  },
]

// Sustentabilidade e Ação Social
export const sust_deparment = [
  {
    name: "Gonçalo Pinheiro",
    role: "Sustentabilidade e Ação Social",
    img: "img/team/Sust_Goncalo.JPG",
    ig: "iam.pinheiro",
    fb: null,
    ld: null
  },
  {
    name: "Laura Cruz",
    role: "Sustentabilidade e Ação Social",
    img: "img/team/Sust_Laura.JPG",
    ig: "l4ura.efc",
    fb: null,
    ld: null
  },
]

// Pedagogico
export const ped_department = [
  {
    name: "Telmo Pereira",
    role: "Pedagogico",
    img: "img/team/Ped_Telmo.JPG",
    ig: "telmoopereira",
    fb: null,
    ld: "telmo-pereira-248968288"
  },
  {
    name: "Mariana Cardoso",
    role: "Pedagogico",
    img: "img/team/Ped_Mariana.JPG",
    ig: "marianna_.25._",
    fb: null,
    ld: "mariana-cardoso-480310321"
  },
]

// BET
export const bet_department = [
  {
    name: "Gustavo Teófilo",
    role: "BET",
    img: "img/team/BET_Gustavo.JPG",
    ig: "guz_ts4",
    fb: null,
    ld: null
  },
  {
    name: "Pedro Luca",
    role: "BET",
    img: "img/team/BET_Pedro.JPG",
    ig: "pedrolucadw",
    fb: null,
    ld: "pedrolucadw"
  },
  {
    name: "Francisca Tomé",
    role: "BET",
    img: "img/team/BET_Francisca.JPG",
    ig: "kikactome",
    fb: null,
    ld: null
  },
  {
    name: "Beatriz Teixeira",
    role: "BET",
    img: "img/team/BET_Beatriz.JPG",
    ig: "biaamft",
    fb: null,
    ld: "beatrizteixeira7"
  },
  {
    name: "Luísa Cruz",
    role: "BET",
    img: "img/team/BET_Luisa.JPG",
    ig: "luisa_cruz04",
    fb: null,
    ld: "luísa-cruz-a30a6a332"
  },
  {
    name: "Matilde Correia",
    role: "BET",
    img: "img/team/BET_Matilde.JPG",
    ig: "matildecorreia4",
    fb: null,
    ld: null
  },
]
